import { render, staticRenderFns } from "./block-insured-vehicle.vue?vue&type=template&id=bdf9fd96&scoped=true"
import script from "./block-insured-vehicle.vue?vue&type=script&lang=js"
export * from "./block-insured-vehicle.vue?vue&type=script&lang=js"
import style0 from "./block-insured-vehicle.vue?vue&type=style&index=0&id=bdf9fd96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf9fd96",
  null
  
)

export default component.exports